// extracted by mini-css-extract-plugin
export default {"authPage":"c-b_c"};